import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import styles from "./login.module.css";
import { signUpExtAdmin } from "./../../../utility/axios-token-manager/auth";
import Flash from "./../../../utility/Flash";
import { loadStart, loadStop } from "./../../../redux/actions/loading";
import { useDispatch } from "react-redux";
import logo from './../../../components/asset/img/Excite WLL.png'

const redirectToLogin = () => {
  setTimeout(() => window.location.assign('/sales-admin/accounts?q=login'), 2000)
}

const getTokenFromUrl = () => {
  const params = new URLSearchParams(window.location.search)
  return params.get('token') || ''
}

const Setup = (props) => {
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [token, setToken] = useState('')
  const [values, setValues] = useState({ email: '', password: '', password2: '' })

  useEffect(() => {
    const urlToken = getTokenFromUrl()
    if (!urlToken) {
      Flash('error', 'Invalid or missing invite link', '', 5000)
    }
    setToken(urlToken)
  }, [])

  const handleChange = (e) => {
    setValues(prev => ({ ...prev, [e.target.name]: e.target.value }))
  }

  const handleSubmit = async () => {
    const email = values.email.trim().toLowerCase()
    const { password, password2 } = values
    if (!email || !password) return Flash('error', 'Missing details', '', 3000)
    if (password !== password2) return Flash('error', 'Passwords do not match', '', 3000)
    if (password.length < 8) return Flash('error', 'Password must be at least 8 characters', '', 3000)
    if (!token) return Flash('error', 'Invalid invite link – no token found', '', 4000)
    try {
      dispatch(loadStart())
      const result = await signUpExtAdmin({ token, email, password })
      dispatch(loadStop())
      if (result) {
        Flash('success', 'Account created successfully', '', 4000)
        redirectToLogin()
      } else {
        Flash('error', 'Invalid or expired invite link', '', 5000)
      }
    } catch (error) {
      dispatch(loadStop())
      Flash('error', 'Server error', '', 5000)
    }
  }

  if (!getTokenFromUrl()) {
    return (
      <section className={styles.section}>
        <div className={"container " + styles.container}>
          <div className={styles.action}>
            <div className={styles.logoWrapper}>
              <a href="/"><img src={logo} alt='logo' /></a>
              <div>Invalid Invite Link</div>
            </div>
            <p className="text-center mt-4" style={{ color: '#c0392b' }}>
              This setup link is missing a token. Please ask your administrator to resend the invite.
            </p>
            <div className={styles.create}>
              <p className="text-center">
                Have an account? <a href="/sales-admin/accounts?q=login">Login</a>
              </p>
            </div>
          </div>
        </div>
      </section>
    )
  }

  return (
    <section className={styles.section}>
      <div className={"container " + styles.container}>
        <div className={styles.action}>
          <div className={styles.logoWrapper}>
            <a href="/"><img src={logo} alt='logo' /></a>
            <div>Set Up Access</div>
          </div>
          <div className={styles.form}>
            <div className={styles.inputWrapper}>
              <i className="fa fa-envelope"></i>
              <input
                onChange={handleChange}
                type="text"
                placeholder="Email"
                name="email"
                value={values.email}
              />
            </div>
            <div className={styles.inputWrapper + " mt-4"}>
              <i className="fa fa-key"></i>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                name="password"
                value={values.password}
                onChange={handleChange}
              />
              <span onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? "Hide" : "Show"}
              </span>
            </div>
            <div className={styles.inputWrapper + " mt-4"}>
              <i className="fa fa-key"></i>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Confirm password"
                name="password2"
                value={values.password2}
                onChange={handleChange}
              />
              <span onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? "Hide" : "Show"}
              </span>
            </div>
          </div>
          <div className={styles.cta}>
            <button onClick={handleSubmit}>Create Account</button>
          </div>
          <div className={styles.create}>
            <p className="text-center">
              Have an account? <a href="/sales-admin/accounts?q=login">Login</a>
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

const mapStateToProps = (state) => ({
  loading: state.loading.isLoading,
})

export default connect(mapStateToProps)(Setup)
